import {Injectable} from '@angular/core';
import {PreferenceService, WmHttpService} from "@wms/services";
import {assign, filter, find, map, sortBy} from "lodash-es";
import {PageMeta} from "@wms/app/services/tree/tree.service";
import {CONSTANTS, getClonedObject, ROUTE_CONSTANTS, StudioUtils} from "@wms/core";
import {environment, EventManagerService} from "@wms/app";
import {runtimeEventManager} from "@wm/core";

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private isTabletType: boolean = false;
  public teamProjectObject: any;
  private TARGET: string = 'PROJECT';
  private API_META: any = {
    sampleApp: {
      url: "/edn-services/rest/projects/import_sample_app?appName=:appName&platformType=:platformType&version=:version",
      method: "POST"
    },
    getSampleApps: {
      url: "/edn-services/rest/projects/sample_apps",
      method: "GET"
    },
    getCategories: {
      url: "/edn-services/rest/artifacts/categories?response-format=LIST",
      method: "GET"
    },
    getArtifact: {
      url: "/edn-services/rest/repository/artifacts/revisions/latest?artifactType=:artifactType&artifactName=:artifactName&branch=:branch",
      method: "GET"
    },
    getDependencies: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/artifacts/:artifactType/dependencies",
      method: "GET"
    },
    getSystemMetadata: {
      url: "/edn-services/rest/system-custom-metadata",
      method: "GET"
    },
    versionAvailableToPublish: {
      url: "/edn-services/rest/repository/artifacts/:artifactId/versions/validate?version=:version",
      method: "GET"
    },
    publishToTeam: {
      url: "/edn-services/rest/repository/queue/artifacts",
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    },
    publishToWorkSpace: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/publishPrefabToWorkspace",
      method: "POST"
    },
    setCategory: {
      url: "/edn-services/rest/artifacts/categories",
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    },
    getEdnDetails: {
      url: "/edn-services/rest/projects/studio/:projectID?withVcsInfoMasked=true",
      method: "GET",
      embedModeAPI: true
    },
    getTeamId: {
      url: "/edn-services/rest/projects/studio/:projectID?withVcsInfoMasked=true",
      method: "GET"
    },
    validators: {
      url : environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/validators",
      method: "GET"
    },
    getProjectUpdates: {
      url : environment.SERVICES_BASE_PATH + "services/projects/:projectID/actions/v1",
      method: "GET",
      spinnerInfo: {
        showSpinner: false
      },
      embedModeAPI: true
    },
    create: {
      url: "/edn-services/rest/projects",
      method: "POST"
    },
    copy: {
      url: environment.SERVICES_BASE_PATH + "services/copy",
      method: "POST"
    },
    remove: {
      url: "/edn-services/rest/projects/:projectID",
      method: "DELETE"
    },
    leave: {
      url: "/edn-services/rest/projects/:projectID/leave",
      method: "DELETE"
    },
    get: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/details",
      method: "GET",
      embedModeAPI: true
    },
    list: {
      url: "/edn-services/rest/users/projects/list",
      method: "GET"
    },
    getProject: {
      url: "/edn-services/rest/projects/:projectID",
      method: "GET"
    },
    getProjectMetadata: {
      url: "/edn-services/rest/projects/:projectID/delete-project-info?studio-project-id=:studioProjectID",
      method: "GET"
    },
    getPagesList: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/pages",
      method: "GET"
    },
    getAppRuntimeVersions: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/app-runtime-versions",
      method: "GET"
    },
    getProjectJavaVersion:{
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/java-version",
      method: "GET"
    },
    updateProjectJavaVersion: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/java-version?javaVersion=:javaVersion",
      method: "POST"
    },

    updateAppRuntimeUIVersion: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/app-runtime-versions/ui-version?appRuntimeUIVersion=:appRuntimeUIVersion",
      method: "POST"
    },

    import: {
      url: "/edn-services/rest/projects/import",
      method: "POST",
      headers: {
        'Content-Type': undefined
      },
      params: {
        "packageType": 'PROJECT'
      }
    },
    reimport: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/reImport",
      method: "POST"
    },
    export: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/export",
      method: "POST"
    },
    exportWar: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/export",
      method: "POST"
    },
    exportAsAngularZip: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/exportAsAngularZip",
      method: "POST"
    },
    exportAsReactZip: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/exportAsReactZip",
      method: "POST"
    },
    exportDependenciesReport: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/export",
      method: "POST"
    },
    exportProjectSummaryReport: {
      url:environment.SERVICES_BASE_PATH + "services/projects/:projectID/projectSummary/export",
      method: "GET",
    },
    exportAsSwagger: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/apidocs/export",
      method: "POST"
    },
    exportFromVCS: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/vcs/export?ref=:vcsRef&zipName=:zipName",
      method: "POST"
    },
    getProjAssociatedVCSInfo: {
      url: "/edn-services/rest/user/vcs/:vcsAccountId",
      method: "GET"
    },
    updateUserVCSCredentials: {
      url: "/edn-services/rest/user/vcs/:vcsAccountId",
      method: "PUT"
    },
    exportForMobileBuild: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/mobile/build/:buildType?profileName=:profileName",
      method: "POST"
    },
    exportForNativeMobileBuild: {
      url : environment.SERVICES_BASE_PATH + "services/projects/:projectID/native-mobile/build/NATIVE_MOBILE?profileName=development",
      method: "POST"
    },
    mobileBuild: {
      url : environment.SERVICES_BASE_PATH + "services/projects/:projectID/mobile/build/:buildType/:platform?profileName=:profileName",
      method: "POST"
    },
    loginToPhoneGap: {
      url : environment.SERVICES_BASE_PATH + "services/projects/:projectId/phonegap/token",
      method: "POST"
    },
    buildPhoneGap: {
      url : environment.SERVICES_BASE_PATH + "services/projects/:projectId/phonegap/apps?token=:token&appId=:appId&profileName=:profileName",
      method: "POST"
    },
    getUserKeys: {
      url : environment.SERVICES_BASE_PATH + "services/projects/:projectId/phonegap/keys?token=:token",
      method: "GET"
    },
    getAppByAppName:{
      url : environment.SERVICES_BASE_PATH + "services/projects/:projectId/phonegap/apps/:appName?token=:token",
      method: "GET"
    },

    saveMobileConfig: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/mobile/config",
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    },
    getMobileConfig : {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/mobile/config",
      method: "GET"
    },
    downloadZip: {
      url: environment.SERVICES_BASE_PATH + "services/download?fileType=zip&packageType=project&sourceName=:projectID&targetName=:path",
      method: "GET"
    },
    getUsers: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/users",
      method: "GET"
    },
    addUser: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/users",
      method: "POST"
    },
    removeUser: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/users",
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json'
      }
    },
    updateDetails: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID",
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      }
    },
    inplaceDeploy: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/deployment/inplaceDeploy",
      method: "POST"
    },
    inplaceUndeploy: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/deployment/inplaceUnDeploy",
      method: "POST"
    },
    deploy: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/deployment/deploy",
      method: "POST"
    },
    getProjectPrefabs: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs",
      method: "GET",
      embedModeAPI: true
    },
    getWorkspacePrefabs: {
      url: environment.SERVICES_BASE_PATH + "services/prefabs?projectID=:projectID",
      method: "GET"
    },
    addBundledPrefabsToWksp: {
      url: "/edn-services/rest/projects/:projectID/artifacts/import",
      method: "POST"
    },
    inspectErrors: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/inspect/results",
      method: "GET"
    },
    inspectJobId: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/inspect",
      method: "GET"
    },
    inspectPolling: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/inspect/status/:jobId",
      method: "GET"
    },
    appEnvironmentProperties: {
      url: environment.SERVICES_BASE_PATH + 'services/projects/:projectID/properties/keys',
      method: 'GET'
    },
    getLogAnalysisRepost:{
      url: '/AnalyzeWithAI/services/restService/:trackId',
      method: 'GET',
      headers: {
        'X-Wm-X-Api-Key' : 'wm-ays-ai-ak1-2305250'
      }
    },
    projectTokenSummary: {
      url: environment.SERVICES_BASE_PATH + 'services/projects/:projectId/projectSummary/tokenInfo',
      method: 'GET'
    }
  };
  private projectId: string;
  private projectDetails: any = {};
  public projectEdnDetails: any;
  private deployedUrl: string;
  private APP_TYPE: any = {
    'APPLICATION': 'APPLICATION',
    'PREFAB': 'PREFAB',
    'TEMPLATEBUNDLE': 'TEMPLATEBUNDLE'
  }
  sqlSuggestions: any
  mysqlSuggestions:any
  public isDesignTokensEnabled = false;

  constructor(private wmHttpService: WmHttpService, private preferenceService: PreferenceService,private eventManager:EventManagerService) {
    wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    runtimeEventManager.setService('projectService', this);
    this.eventManager.updateActiveThemeObservable().subscribe((theme: any) => {
      this.projectDetails.activeTheme = theme
    });
  }

  getAppRunURL(showSpinner?: boolean) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'inplaceDeploy',
      pathParams: {
        projectID: this.getProjectId()
      },
      spinnerInfo: {
        showSpinner: showSpinner
      }
    }) as Promise<any>).then((response) => {
      this.setAppDeployedUrl(response.result)
      });
  }

  getRNBuildConfig() {
    return (this.wmHttpService.execute({
      target: "FILE",
      action: "read",
      pathParams:{
        filePath: "../project/src/main/webapp/wm_rn_config.json",
        projectID: this.getProjectId()
      }
    }) as Promise<any>)
  }

  getEslintOverrideConfig() {
    return (this.wmHttpService.execute({
      target: "FILE",
      action: "read",
      pathParams:{
        filePath: "../project/build-src/eslintrc-override.js",
        projectID: this.getProjectId()
      },
      spinnerInfo: {
        showSpinner: false,
      },
    }) as Promise<any>)
  }

  loadDetails() {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'get',
      pathParams:{
        projectID: this.getProjectId()
      }
    }) as Promise<any>).then((response)=>{
      this.projectDetails = response;
      if (this.isNativeMobileApplicationType()) {
        (this.getRNBuildConfig() as Promise<any>).then((response: any) => {
          const config = JSON.parse(response);
          this.isDesignTokensEnabled = !!config?.preferences?.enableDesignTokens;
        });
      }
    });
  }

  loadDetailsAndPreferences() {
    return new Promise((resolve, reject) => {
      this.loadDetails().then(()=>{
        this.preferenceService.load(this.projectDetails).then(resolve).catch(reject);
      }).catch((errorObject:any) => {
          if (errorObject.status === 401) {
            StudioUtils.redirectToLoginPage();
        } else {
            StudioUtils.redirectToIndexPage(ROUTE_CONSTANTS.PROJECT_STATUS.replace(":status", errorObject.status));
        }
      })
    })
  }

  loadEdnDetails() {
    if(this.projectEdnDetails){
      return Promise.resolve(this.projectEdnDetails);
    }
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getEdnDetails',
      pathParams:{
        projectID: this.getProjectId()
      }
    }) as Promise<any>).then((response)=>{
      return this.projectEdnDetails = this.teamProjectObject = response;
    });
  }

  getTeamId (){
    return(this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getTeamId',
      urlParams: {
        projectID:this.getProjectId()
      }
    }) as Promise <any>)
  }



  getProjectPrefabs(showSpinner: boolean = false) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getProjectPrefabs',
      pathParams:{
        projectID: this.getProjectId()
      },
      spinnerInfo: {
        showSpinner: showSpinner
      }
    }) as Promise<any>);
  }

  getProjectUpdates() {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getProjectUpdates',
      pathParams:{
        projectID: this.getProjectId()
      }
    }) as Promise<any>);
  }

  getWorkspacePrefabs(showSpinner: boolean = false) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getWorkspacePrefabs',
      pathParams:{
        projectID: this.getProjectId()
      },
      spinnerInfo: {
        showSpinner: showSpinner
      }
    }) as Promise<any>);
  }

  addBundledPrefabsToWksp(projectID:any, list:any ){
    return(this.wmHttpService.execute({
      target: this.TARGET,
      action: "addBundledPrefabsToWksp",
      data: list,
      toasterInfo: { 'error'  : { title: 'Error' } },
      urlParams: {
        projectID: projectID
      }
    })as Promise <any> )
  }



  getDetails() {
    return this.projectDetails
  }

  isPrettificationEnabled() {
    return this.projectDetails?.properties?.enablePrettification === 'true' || this.projectDetails?.properties?.enablePrettification === true;
  }

  /**
   * @ngdoc function
   * @name wm.common.$ProjectService#getPageNames
   * @methodOf wm.common.$ProjectService
   * @function
   *
   * @description
   *  get the page names of the current project.
   */
  getPageNames(type?: any) {
    let pages;
    if (type) {
      pages = filter(this.projectDetails.pages, {'type' : type});
      return sortBy(getClonedObject(map(pages, 'name')));
    }
    return sortBy(getClonedObject(this.projectDetails.pageNames));
  }

  getProjectEdnDetails() {
    return this.projectEdnDetails;
  }

  getAppDeployedUrl() {
    return this.deployedUrl;
  }

  getProjectId() {
    return this.projectId;
  }

  getProjectPlatformType() : string {
    return this.projectDetails.platformType;
  }

  setProjectId(id: string) {
    this.projectId = id;
  }

  setDetails(projectInfo: any) {
    let pages = this.projectDetails.pages; //save the pages object, as the project info response do not have pages object
    this.projectDetails = projectInfo;
    this.setPages(pages);
  };

  setPages(pages: Array<PageMeta>) {
    this.projectDetails.pages = pages;
    this.projectDetails.pageNames = map(pages, 'name');

    // $rootScope.$emit('wms:pages-meta-load', Utils.getClonedObject(pages));
  };

  getPageInfo(pageName?: string) {
    return find(this.projectDetails.pages, (page: PageMeta) => {
      return page.name === pageName;
    }) || {};
  };

  //isApplicationType returns true if the project is of type application
  isApplicationType() {
    return this.projectDetails.type === 'APPLICATION';
  }

  //isPrism returns true if the project is of type 'prism'
  isPrism() {
    return this.getProjectTemplate() === 'PRISM';
  }

  isAutolayoutAllowed(){
    return this.getProjectTemplate() === 'PRISM' && this.projectDetails.platformType === 'WEB';
  }

  isPrismWeb() {
    return this.getProjectTemplate() === 'PRISM' && this.projectDetails.platformType === 'WEB';
  }

  getProjectTemplate() {
    return this.projectDetails.template;
  }

  getHomePage() {
    return this.projectDetails.properties.homePage;
  }

  getActiveTheme() {
    return this.projectDetails.activeTheme || CONSTANTS.DEFAULT_THEME;
  }

  isMobileApplicationType() {
    return (this.projectDetails.platformType === 'MOBILE' || this.projectDetails.platformType === 'NATIVE_MOBILE') && this.projectDetails.type === 'APPLICATION';
  }

  isNativeMobileApplicationType() {
    return this.projectDetails.type === 'APPLICATION' && this.projectDetails.platformType === 'NATIVE_MOBILE';
  }

  isWebApplicationType() {
    return this.projectDetails.type === 'APPLICATION' && this.projectDetails.platformType === 'WEB';
  }

  isTabletApplicationType() {
    return this.isTabletType || (this.projectDetails.type === 'APPLICATION' && this.projectDetails.properties.deviceTypes === 'TABLET');
  }

  setTabletType(flag: boolean) {
    this.isTabletType = flag;
  }

  getCategories() {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getCategories'
    }) as Promise<any>);
  }

  getArtifact(urlParams: any) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getArtifact',
      urlParams: {
        artifactName  : urlParams.artifactName,
        artifactType  : urlParams.artifactType,
        branch        : urlParams.branch
      }
    }) as Promise<any>);
  }

  getDependencies(artifactType: string) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getDependencies',
      urlParams: {
        projectID     : this.getProjectId(),
        artifactType  : artifactType
      }
    }) as Promise<any>);
  }


  getSystemMetadata() {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getSystemMetadata'
    }) as Promise<any>);
  }

  versionAvailableToPublish(urlParams: any) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'versionAvailableToPublish',
      urlParams: {
        artifactId  : urlParams.artifactId,
        version     : urlParams.version
      }
    }) as Promise<any>);
  }
  setCategory(requestBody: any) {
    return (this.wmHttpService.execute({
      target  : this.TARGET,
      action  : 'setCategory',
      data    : requestBody
    }) as Promise<any>);
  }
  publishToTeam(requestBody: any) {
    return (this.wmHttpService.execute({
      target  : this.TARGET,
      action  : 'publishToTeam',
      data    : requestBody
    }) as Promise<any>);
  }

  publishToWorkSpace(requestBody: any) {
    return (this.wmHttpService.execute({
      target  : this.TARGET,
      action  : 'publishToWorkSpace',
      pathParams: {
        projectID: this.getProjectId()
      },
      data    : requestBody
    }) as Promise<any>);
  }

  getProjAssociatedVCSInfo(vcsAccountId: any) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getProjAssociatedVCSInfo',
      pathParams: {
        vcsAccountId: vcsAccountId
      }
    }) as Promise<any>);
  }

  updateUserVCSCredentials(params: any) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'updateUserVCSCredentials',
      pathParams: {
        vcsAccountId: params.vcsAccountId
      },
      data: params.data,
    }) as Promise<any>);
  }
  setAppDeployedUrl(url: string) {
    this.deployedUrl = url;
  }
  getDeployedUrl() : string {
    return this.deployedUrl;
  }

  /**
  * @ngdoc function
  * @name wm.common.$ProjectService#import
  * @methodOf wm.common.$ProjectService
  * @function
  * @description
  * imports a project into the studio.
  * @param {object} details Details object
  */
  import(details: any) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: details.action,
      data: details.content,
      spinnerInfo: {
        showSpinner: false
      },
      urlParams: {
        projectID: this.getProjectId(),
        displayName: details.displayName
      }
    }) as Promise<any>);
  }

  /**
   * @ngdoc function,
   * @name #projectProvatars
   * @methodOf ProjectService
   * @function
   * @description
   * returns the list of project avatars.
   */
  projectProvatars() {
    return new Promise((resolve, reject) => {
      import(`../../../assets/resources/files/studio-provatars.json`).then((res) => {
        resolve(res);
      });
    });
  }

  getJsonData(path: any) {
    return this.wmHttpService.get(path);
  }

  saveNativeMobileBuildConfig(details: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: "FILE",
      action: "write",
      pathParams: {
        filePath: "../project/src/main/webapp/wm_rn_config.json",
        projectID: this.getProjectId()
      },
      data: details.config
    }) as Promise<any>);
  }

  updateDetails(params: any): Promise<any> {
    assign(params.projectDetails, {
      'projectType': this.projectDetails.properties.type,
      'platformType': this.getProjectPlatformType() || 'WEB',
      'template': this.getProjectTemplate() || 'DEFAULT'
    });

    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'updateDetails',
      pathParams: {
        projectID: this.getProjectId()
      },
      data: params.projectDetails,
    }) as Promise<any>);
  }

  /**
   * @ngdoc function
   * @name wm.common.$ProjectService#getInspectErrors
   * @methodOf wm.common.$ProjectService
   * @function
   * @description
   * get inspect errors for the studio
   */
  getInspectErrors(): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'inspectErrors',
      urlParams: {
        projectID: this.getProjectId()
      },
      spinnerInfo: {
        showSpinner: false
      }
    })) as Promise<any>;
  }

  /**
   * @ngdoc function
   * @name wm.common.$ProjectService#getInspectJobId
   * @methodOf wm.common.$ProjectService
   * @function
   * @description
   * get inspect jobid for the studio
   */
  getInspectJobId(): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'inspectJobId',
      urlParams: {
        projectID: this.getProjectId()
      },
      spinnerInfo: {
        showSpinner: false
      }
    })) as Promise<any>;
  }

  /**
   * @ngdoc function
   * @name wm.common.$ProjectService#inspectPolling
   * @methodOf wm.common.$ProjectService
   * @function
   * @description
   * get inspect jobid for the studio
   */
  inspectPolling(params: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'inspectPolling',
      urlParams: {
        projectID: this.getProjectId(),
        jobId: params.jobId
      },
      spinnerInfo: {
        showSpinner: false
      }
    })) as Promise<any>;
  }

  getPagesList(): Promise<any> {
    if(this.projectDetails.pages){
      return Promise.resolve(this.projectDetails.pages);
    }
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "getPagesList",
      pathParams: {
        projectID: this.getProjectId()
      }
    }) as Promise<any>).then((pages: any) => {
      this.setPages(pages);
      return this.projectDetails.pages;
    });
  }

  validateName(name: string): boolean {
    var projectNameRegEx = /^[\w|_ ]+$/;
    if (!name) {
      return false;
    }
    return projectNameRegEx.test(name);
  };

  isPrefabTemplate(): boolean {
    return this.projectDetails.type === 'PREFAB';
  }

  isPrefabType(): boolean {
    return this.projectDetails.type === this.APP_TYPE.PREFAB;
  }

  isTemplateBundleType(): boolean {
    return this.projectDetails.type === this.APP_TYPE.TEMPLATEBUNDLE;
  }

  export(details: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "export",
      data: {
        "exportType": details.exportType,
        "targetName": details.targetName,
        "excludeGeneratedUIApp": true
      },
      urlParams: {
        projectID: details.projectId
      }
    }) as Promise<any>)
  }

  exportForNativeMobileBuild(details: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "exportForNativeMobileBuild",
      urlParams: {
        projectID: details.projectId
      }
    }) as Promise<any>);
  }

  exportAsSwagger(details: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "exportAsSwagger",
      urlParams: {
          projectID: details.projectId
      }
    }) as Promise<any>)
  }

  exportWar(details: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "exportWar",
      data: {
        exportType: details.exportType,
        profileName: details.profileName
      },
      urlParams: {
          projectID: details.projectId,
      }
    }) as Promise<any>)
  }

  exportAsAngularZip(details: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "exportAsAngularZip",
      urlParams: {
        projectID: details.projectId,
      }
    }) as Promise<any>)
  }
  exportAsReactZip(): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "exportAsReactZip",
      urlParams: {
        projectID: this.projectId,
      }
    }) as Promise<any>)
  }


  exportDependenciesReport(details: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "exportDependenciesReport",
      data: {
         exportType: details.exportType
      },
      urlParams: {
          projectID: details.projectId
      }
    }) as Promise<any>);
  }

  exportProjectSummaryReport(): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "exportProjectSummaryReport",
      urlParams: {
        projectID: this.projectId
      }
    }) as Promise<any>);
  }

  appEnvironmentProperties() {
    return this.wmHttpService.execute({
      target: this.TARGET,
      action: "appEnvironmentProperties",
      pathParams: {
        projectID: this.projectId
      },
    })
  }

  getProjectDetails(branchTypes:string, showSpinner?: boolean) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'list',
      pathParams:{
        branchTypes: branchTypes
      },
      spinnerInfo: {
        showSpinner: showSpinner
      }
    }) as Promise<any>);
  }

  clean(projectId:any){
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'inplaceUndeploy',
      pathParams:{
        "projectId": projectId
      },
    }) as Promise<any>);

  }
  getAppRuntimeVersion(projectId:any){
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getAppRuntimeVersions',
      pathParams:{
        "projectID": projectId
      },
    }) as Promise<any>);

  }
  getProjectJavaVersion(){
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getProjectJavaVersion',
      pathParams:{
        "projectId": this.getProjectId()
      },
    }) as Promise<any>);
  }

  updateProjectJavaVersion(version:string){
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'updateProjectJavaVersion',
      pathParams:{
        projectId : this.getProjectId(),
        javaVersion: version
      },
    }) as Promise<any>);
  }


  updateAppRuntimeUIVersion( projectId:any,appRuntimeUIVersion:any){
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'updateAppRuntimeUIVersion',
      pathParams:{
        projectId : projectId,
        appRuntimeUIVersion: appRuntimeUIVersion
      },
    }) as Promise<any>);
  }

  validators(projectId:any){
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'validators',
      spinnerInfo: {
        showSpinner: false
      },
      pathParams:{
        projectID : projectId
      },
    }) as Promise<any>);
  }

  shouldUseShadowDom() {
    const isWebOrPrefab = this.isWebApplicationType() || this.isPrefabType();
    return (this.isPrism() && this.isApplicationType() && !this.isNativeMobileApplicationType())
    || isWebOrPrefab
  }
  getLogAnalysisRepost(trackId:string){
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getLogAnalysisRepost',
      spinnerInfo: {
        showSpinner: true
      },
      pathParams:{
        trackId:trackId
      }

    }) as Promise<any>);

  }

  getProjectTokenSummary(projectId:any){
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'projectTokenSummary',
      pathParams:{
        "projectId": projectId
      },
    }) as Promise<any>);
  }

}
